var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 56,
    viewBox: "0 0 38 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00385437 46.9217C6.16038 41.913 10.9604 37.7391 14.4039 34.4C17.8995 31.0609 20.456 28.0609 22.0734 25.4C23.743 22.687 24.5778 20.0261 24.5778 17.4174C24.5778 14.6 23.6647 12.513 21.8386 11.1565C20.0647 9.74782 17.7169 9.04348 14.7952 9.04348C10.6734 9.04348 6.47342 10.2696 2.19516 12.7217L1.09951 3.64347C3.29081 2.6 5.79516 1.81739 8.61255 1.29565C11.4299 0.721734 14.3517 0.434778 17.3778 0.434778C20.8212 0.434778 23.9517 1.03478 26.7691 2.23478C29.6386 3.38261 31.9082 5.15652 33.5778 7.55652C35.2473 9.90435 36.0821 12.8 36.0821 16.2435C36.0821 18.5913 35.6647 20.887 34.8299 23.1304C33.9952 25.3739 32.6126 27.7739 30.6821 30.3304C28.7517 32.8348 26.1169 35.6522 22.7778 38.7826C19.1256 42.2261 15.4995 45.1478 11.8995 47.5478V47.7043C16.856 47.5478 22.256 47.4696 28.0995 47.4696H37.256V56H0.00385437V46.9217Z",
    fill: "#0B5ED7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.0f78192bf3069db2d612f81c0eee58ea.svg";
export { ForwardRef as ReactComponent };